module.exports = __webpack_public_path__ + "img/kv_sp.0b6fa0d9.jpg";